import { createSelector } from 'reselect';
import { getCustomSensor } from '../rootSelectors';

const getCustomSensorSelector = createSelector([getCustomSensor], customSensor => customSensor);

export { getCustomSensorSelector };
